// extracted by mini-css-extract-plugin
export var footer = "_r4-0";
export var inherit = "_r4-1";
export var input = "_r4-2";
export var modalContent = "_r4-3";
export var quillEditor = "_r4-4";
export var subtitle = "_r4-5";